import { render } from "./ColorInput.vue?vue&type=template&id=4c06f934"
import script from "./ColorInput.vue?vue&type=script&lang=ts"
export * from "./ColorInput.vue?vue&type=script&lang=ts"
script.render = render

export default script